"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcMs = void 0;
var function_1 = require("./function");
/**
 * Calculates the equivalent number of milliseconds based on the given time string.
 * Supports units of seconds, minutes, hours, days, and weeks.
 *
 * @param s The time string in the format: `${value} ${unit}`.
 *          - `${value}` is a positive integer representing the quantity.
 *          - `${unit}` is one of the supported time units: 's', 'sec', 'second', 'seconds',
 *            'm', 'min', 'minute', 'minutes', 'hr', 'hrs', 'hour', 'hours',
 *            'd', 'dy', 'day', 'days', 'wk', 'wks', 'week', 'weeks'.
 *
 * @returns The calculated equivalent number of milliseconds.
 *
 * @example
 * ```ts
 * // Returns: 60000 (1 minute in milliseconds)
 * calcMs('1m');
 * ```
 *
 * @example
 * ```ts
 * // Returns: 86400000 (1 day in milliseconds)
 * calcMs('1 day');
 * ```
 *
 * @example
 * ```ts
 * // Throws: Error('Failed to parse given time string!')
 * calcMs('10'); // Invalid input, no unit specified
 *
 * // note: this will also throw a *type* error, however if you are not checking types before execution the method's error will be thrown.
 * ```
 */
function calcMs(s) {
    var calcFromSeconds = function (n) { return n * 1000; };
    var calcFromMinutes = function (n) { return (0, function_1.pipe)(n * 60, calcFromSeconds); };
    var calcFromHours = function (n) { return (0, function_1.pipe)(n * 60, calcFromMinutes); };
    var calcFromDays = function (n) { return (0, function_1.pipe)(n * 24, calcFromHours); };
    var calcFromWeeks = function (n) { return (0, function_1.pipe)(n * 7, calcFromDays); };
    var regex = /^(\d+)(?:\s+)?(.+)$/; // Regex to extract the number and unit
    var matches = s.match(regex);
    if (matches) {
        var _a = __read(matches, 3), value = _a[1], unit = _a[2];
        var numericValue = parseInt(value, 10);
        switch (unit) {
            case "s":
            case "sec":
            case "second":
            case "seconds":
                return calcFromSeconds(numericValue);
            case "m":
            case "min":
            case "minute":
            case "minutes":
                return calcFromMinutes(numericValue);
            case "hr":
            case "hrs":
            case "hour":
            case "hours":
                return calcFromHours(numericValue);
            case "d":
            case "dy":
            case "day":
            case "days":
                return calcFromDays(numericValue);
            case "wk":
            case "wks":
            case "week":
            case "weeks":
                return calcFromWeeks(numericValue);
        }
    }
    throw new Error("Failed to parse given time string!");
}
exports.calcMs = calcMs;
